import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../analytics';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/3968
export const emitCreateNewTaskEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3968',
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zrm_maintenance',
      trigger_source_nm: 'create_a_new_task',
      trigger_object_nm: 'task_creation_modal',
    },
    semantic: {
      semantic_event_nm: 'zrm_maintenance',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3970
export const emitCloseTaskWithoutMakingTaskEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: '3970',
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zrm_maintenance',
      trigger_source_nm: 'cancel',
      trigger_object_nm: 'task_creation_modal',
    },
    semantic: {
      semantic_event_nm: 'zrm_maintenance',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
  });
